'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlForMessage = undefined;

var _hubspotUrlinator = require('hubspot.urlinator.Url');

var _hubspotUrlinator2 = _interopRequireDefault(_hubspotUrlinator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUrlForMessage = exports.getUrlForMessage = function getUrlForMessage() {
  var url = window.location !== window.parent.location ? document.referrer : document.origin;

  var parsedUrl = new _hubspotUrlinator2.default(url);

  return parsedUrl.hostplus;
};